import { render, staticRenderFns } from "./BoxesTable.vue?vue&type=template&id=7b91b858&scoped=true&"
import script from "./BoxesTable.vue?vue&type=script&lang=js&"
export * from "./BoxesTable.vue?vue&type=script&lang=js&"
import style0 from "./BoxesTable.vue?vue&type=style&index=0&id=7b91b858&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b91b858",
  null
  
)

export default component.exports